import { Navigate, Outlet, useLocation, useSearchParams } from "react-router-dom";
import Constants from '../Constants';
import { useEffect } from "react";
import { initializeSocket } from "../services/SocketService";
import { setLocalStorageItem } from "../utils/localStorageUtil";

const ProtectedRoute = () => {
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();

    // Handle token from URL query params (for Chart Squad iframe integration)
    useEffect(() => {
        const tokenFromUrl = searchParams.get('token');
        const currentToken = Constants.getAuthtoken();
        
        // If token exists in URL and no token in localStorage, store it
        if (tokenFromUrl && !currentToken?.isToken) {
            setLocalStorageItem("authtoken", tokenFromUrl);
            // Remove token from URL for security
            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.delete('token');
            setSearchParams(newSearchParams, { replace: true });
        }
    }, [searchParams, setSearchParams]);

    useEffect(() => {
        initializeSocket();
    }, []);

    console.log(window.location.hostname,"window.location.hostname"); 
    
    // Check for token in URL first (for iframe), then localStorage
    const tokenFromUrl = searchParams.get('token');
    const currentToken = Constants.getAuthtoken();
    const hasToken = tokenFromUrl || currentToken?.isToken;
    
    if (!hasToken) {
       let  redirectPath = ""
        if(window.location.hostname === "master.demandpro.law") {
            redirectPath= '/account/SAlogin'
        } else if(window.location.hostname !== "master.demandpro.law") {
            redirectPath='/account/login'}
        return <Navigate to={redirectPath}
            replace
            state={{ from: location }} />;
    }
    return <Outlet />;
};
export default ProtectedRoute;